class ContextElementClass {
    public ContextCode: string;
    public ContextDescription: string;

    constructor(code?: string, description?: string) {
        this.ContextCode = code;
        this.ContextDescription = description;
    }
}

export { ContextElementClass };
